/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { login } from "../../services/http/login";
// import logo from "../../assets/images/brand/logo.png";
import { changeClass, removeClass } from "../../utils/utility";
import useStore from "../../store";
import { Link } from "react-router-dom";
import { useScrollLock } from "../../utils/scrollLock/scrollLock";
import DomainLogo from "components/shared/Domain";

const Login = () => {
  const { lockScroll, unlockScroll } = useScrollLock();
  const setAuth = useStore.userStore((state) => state.setAuth);
  const setLoader = useStore.loaderStore((state) => state.setLoader);
  const [formData, SetFormData] = useState({ showPassword: false });
  const [showPassword, handleShowPassword] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [selectedEnv, setSelectedEnv] = useState("UAT");
    const [showButton, setShowButton] = useState(false);
  const popoverRef = useRef(null);

  // Close on outside click
  useEffect(() => {
      const url = window.location.href;
    const shouldShow = url.includes("dev") || url.includes("uat") || url.includes("localhost");
    setShowButton(shouldShow);
    function handleClickOutside(event) {
      // If popoverRef exists and click is outside of it, AND not a native select dropdown
        
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        event.target.tagName !== "OPTION"
      ) {
        setShowPopover(false);
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  

  const environments = [
    "UAT"
    ];

  useEffect(() => {
    localStorage.setItem("ENV", selectedEnv);
  }, [selectedEnv]);


  const handleTextChange = (e) => {
    const { name, value } = e.target;
    SetFormData({ ...formData, [name]: value });
  };

  const showPasswordFunction = () => {
    handleShowPassword(!showPassword);
  };



  
  const validateForm = () => {
    return !formData?.name || !formData?.password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const resp = await login(formData);
      setAuth(resp);
      unlockScroll();
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    lockScroll();
    document.body.style.overflow = "hidden"; // Prevent scrolling
    document.getElementById("username").focus();
    changeClass("login-img");
  
    return () => {
      unlockScroll();
      document.body.style.overflow = ""; // Restore scrolling
      removeClass("login-img");
    };
  }, []);
  
  const forgotPasswordTab = () => {
    window.open("https://www.greenyourbills.com/Bill_Sys_ForgotPassword.aspx");
  };


  return (
    <>
    {/* Floating Popover Button at Top-Left */}


      <div className="page">
      <div className="fixed top-4 left-4 z-50 override-text-left" ref={popoverRef}>
  <div className="relative inline-block text-left">
    {/* Gear Button */}
   { showButton && (<button
      onClick={() => setShowPopover((prev) => !prev)}
      className="bg-gray-800 text-white p-2 shadow hover:bg-gray-700 ml-2 bgc-gray"    >
      <i className="fa fa-cogs" style={{ fontSize: "18px" }} />
    </button>
   )
}

    {/* Popover */}
    {showPopover && (
      <div
        className="absolute top-full left-0 ml-1 mt-2 bg-white border border-gray-300 shadow-lg p-4 text-sm z-50 bring-ele-at-top"
        style={{ width: "256px", position: "absolute"}}
      >
        <h6 className="font-semibold mb-2"><strong>Configure your domain.</strong></h6>
        <p className="text-gray-600 mb-2 text-xs">
          For example if your website is www.websiteDomain.com enter websiteDomain
        </p>
        <select
          value={selectedEnv}
          onChange={(e) => setSelectedEnv(e.target.value)}
          className="w-full p-2 border text-sm"
        >
          {environments.map((env) => (
            <option selected key={env} value={env}>
              {env}
            </option>
          ))}
        </select>
      </div>
    )}
  </div>
</div>
        <div className="container-login100">
          <div
            className="wrap-login100 p-6 md:tw-w-1/2 sm:tw-w-1/2 lg:tw-w-1/4"
            style={{ minWidth: "265px" }}
          >
            <form
              className="login100-form validate-form"
              onSubmit={handleSubmit}
            >
              <div>
                <div className="tw-flex tw-items-center tw-justify-center">
                  {/* <img src={logo} alt="logo" /> */}
                  <DomainLogo  />

                </div>
                <div className="tw-flex tw-items-center tw-justify-center">
                  <h4 className="cursFont">Provider Portal</h4>
                </div>
                <div className="panel panel-primary">
                  <div className="panel-body tabs-menu-body p-0 pt-5">
                    <div className="tab-content">
                      <div className="tab-pane active" id="tab5">
                      <div
                            className="wrap-input100 validate-input input-group"
                            data-bs-validate="Valid email is required: ex@abc.xyz"
                          >
                            <a
                              style={{ paddingInline: "14px" }}
                              className="input-group-text bg-white text-muted"
                            >
                              <i
                                className="zmdi zmdi-account text-muted"
                                aria-hidden="true"
                              />
                                                      </a>
                          <input
                            id="username"
                            onChange={(e) => handleTextChange(e)}
                            className="input100 border-start-0"
                            type="text"
                            name="name"
                            placeholder="Username"
                          />
                        </div>
                        <div
                            className="wrap-input100 validate-input input-group"
                            id="Password-toggle"
                          >
                            <a
                              onClick={() => showPasswordFunction()}
                              className="input-group-text bg-white text-muted"
                            >
                              <i
                                className={
                                  showPassword
                                    ? "zmdi  zmdi-eye-off text-muted"
                                    : "zmdi zmdi-eye text-muted"
                                }
                                aria-hidden="true"
                              />
                            </a>
                          <input
                             onChange={(e) => handleTextChange(e)}
                            name="password"
                            className="input100 border-start-0"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                          />
                        </div>
                        <div className="container-login100-form-btn">
                        <button
                              style={{
                                paddingLeft: "20px",
                                paddingRight: "20px",
                              }}
                              disabled={validateForm() ? true : false}
                              to=""
                              className="loginButtonClassName btn btn-primary float-right mr-1"
                            >
                              Login
                            </button>
                        </div>
                        <div className="mt-2">
                          <Link onClick={forgotPasswordTab}>Forgot Password</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
